var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7334_10638",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7334_10638)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0502 15.15L18.5252 6.675C18.7252 6.475 18.9585 6.375 19.2252 6.375C19.4919 6.375 19.7252 6.475 19.9252 6.675C20.1252 6.875 20.2252 7.1125 20.2252 7.3875C20.2252 7.6625 20.1252 7.9 19.9252 8.1L10.7502 17.3C10.5502 17.5 10.3169 17.6 10.0502 17.6C9.78354 17.6 9.55021 17.5 9.35021 17.3L5.05021 13C4.85021 12.8 4.75437 12.5625 4.76271 12.2875C4.77104 12.0125 4.87521 11.775 5.07521 11.575C5.27521 11.375 5.51271 11.275 5.78771 11.275C6.06271 11.275 6.30021 11.375 6.50021 11.575L10.0502 15.15Z",
    fill: "#1976D2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckBlue);
export default __webpack_public_path__ + "static/media/check_blue.492e01e838b972504992d11d40f89f79.svg";
export { ForwardRef as ReactComponent };